export default __webpack_public_path__ + "static/media/conscious.53c139a4.svg";